// Define flags
export const DEFAULT_CHANNEL = false;
export const DEFAULT_CHANNEL_VALUE = 1;
export const SHOW_OVERVIEW_DASHBOARD = true;
export const SHOW_ADMIN_USERS = true;
export const SHOW_REPORTS_OVERVIEW_VIDEOS = true;
export const SHOW_CONTENT_CHANNELS = true;
export const SHOW_CONTENT_VIDEOS = true;
export const SHOW_CONTENT_CATEGORIES = true;
export const SHOW_REPORTS_VIDEO_WATCH_SESSIONS = true;
export const SHOW_REPORTS_WATCH_SESSIONS = true;
export const SHOW_SUBSCRIBERS = true;
export const SHOW_REPORTS_APP_SESSIONS = true;
export const SHOW_COLLECTION = true;

// Define commonly used constants
export const LS_ADMIN_USER_ID = '__sl_admin_i';
export const LS_ADMIN_USER_AUTH_TOKEN = '__sl_admin_t';
export const LS_ADMIN_USER_NAME = '__sl_admin_n';
export const LS_ADMIN_USER_EMAIL = '__sl_admin_e';
export const LS_ADMIN_USER_ROLE = '__sl_admin_r';

export const STATUS_LABELS = {
  0: 'Inactive',
  1: 'Active',
  2: 'Deleted',
  5: 'Requested Delete',
  11: 'Pending Verification',
  12: 'Cancellation Applied',
};
export const ACCEPTANCE_LABELS = {
  0: 'No',
  1: 'Yes',
};

export const STATUS_COLORS = {
  0: 'error',
  1: 'success',
  2: 'error',
  5: 'warning',
  11: 'warning',
  12: 'warning',
};

export const CONTENT_ALIAS = {
  CHANNEL_SINGULAR: 'Channel',
  CHANNEL_PLURAL: 'Channels',
  CATEGORY_SINGULAR: 'Category',
  CATEGORY_PLURAL: 'Categories',
  VIDEO_SINGULAR: 'Video',
  VIDEO_PLURAL: 'Videos',
  CONTENT: 'Content',
  USER_SINGULAR: 'User',
  USER_PLURAL: 'Users',
  COLLECTION_SINGULAR: 'Collection',
  COLLECTION_PLURAL: 'Collections',
};

export const CATEGORY_OPTIONS = {
  old: {
    shorthand: 'old',
    title: 'OLD TESTAMENT STUDY',
    displayText: 'Old Testament',
    path: 'old',
  },
  new: {
    shorthand: 'new',
    title: 'NEW TESTAMENT STUDY',
    displayText: 'New Testament',
    path: 'new',
  },
};

export const ADMIN_USER_ROLE = {
  ADMIN: 'ADMIN',
  CONTENT_OWNER: 'CONTENT_OWNER',
};

export const ACTIONS = {
  CREATE: {
    value: 'create',
    label: 'Create New',
  },
  EDIT: {
    value: 'update',
    label: 'Edit',
  },
  VIEW: {
    value: 'view',
    label: 'View',
  },
  DELETE: {
    value: 'delete',
    label: 'Delete',
  },
  CHANGE_PASSWORD: {
    value: 'change_password',
    label: 'Change Password',
  },
  UPLOAD_ASSETS: {
    value: 'upload_assets',
    label: 'Upload Assets',
  },
  UPLOAD_BACKGROUND: {
    value: 'upload_background',
    label: 'Upload Background',
  },
  DOWNLOAD: {
    value: 'download',
    label: 'Download',
  },
  SEQUENCE: {
    value: 'sequence',
    label: 'Manage Sequence',
  },
  ASSIGN_VIDEO: {
    value: 'assign_video',
    label: `Assign ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  },
  CONFIG: {
    value: 'config',
    label: 'Config',
  },
  ASSIGN_COLLECTION_CATEGORIES: {
    value: 'assign_collection_categories',
    label: `Assign ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  },
  CATEGORY_SEQUENCE: {
    value: 'category_sequence',
    label: 'Manage Category Sequence',
  },
  COLLECTION_SEQUENCE: {
    value: 'collection_sequence',
    label: 'Manage Collection Sequence',
  },
};

// Place it in CSS file
export const FOCUS_PALETTE_BGCOLOR = 'rgba(255, 255, 255, 0.25)';
